module.exports = __webpack_public_path__ + "f6b76fdad455506ea946c9eda8be69a8.png";